import { jsx as _jsx } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { WalletConnectDialog as ToolkitWalletConnect } from "@sundae/ui-toolkit";
import { useIsWalletConnected } from "../../../hooks/useIsWalletConnected.js";
import { useWalletConnectFlow } from "../../../hooks/useWalletConnectFlow.js";
import WalletConnectLegalDisclaimer from "../../../i18n/components/wallet/WalletConnectLegalDisclaimer/index.js";
import { useAppContext } from "../../../stores/index.js";
import NoDataIndicator from "../../NoDataIndicator/index.js";
const WalletConnectDialog = () => {
    const { t } = useI18N("wallet");
    const isWalletConnected = useIsWalletConnected();
    const { state: { platformLinks }, } = useAppContext();
    const { error, handleCloseWalletConnectDialog, handleConnect, isConnectingWallet, walletConnectOpen, } = useWalletConnectFlow();
    return (_jsx(ToolkitWalletConnect, { i18n: {
            error: error,
            learnMore: t("connectDialog.learnMore"),
            noWallets: t("connectDialog.noWalletsCopy"),
            description: t("connectDialog.description"),
            suggestWallet: t("connectDialog.suggestWallet"),
            title: t("connectDialog.title"),
            selectWalletNotice: t("connectDialog.selectWalletNotice"),
            walletConnect: t("button.connect"),
        }, isWalletConnected: isWalletConnected, legalDisclaimer: _jsx(WalletConnectLegalDisclaimer, {}), isLoading: isConnectingWallet, learnMoreRoute: platformLinks.learnMoreAboutWallets, noWalletsComponent: _jsx(NoDataIndicator, { context: "wallet" }), onConnectWallet: handleConnect, onClose: () => {
            handleCloseWalletConnectDialog();
        }, open: walletConnectOpen, suggestWalletRoute: platformLinks.learnMoreAboutWallets }));
};
export default WalletConnectDialog;
//# sourceMappingURL=WalletConnectDialog.js.map